import React from "react";
import {
  Select,
  OutlinedInput,
  Chip,
  Box,
  FormControl,
  ListItemText,
  MenuItem,
} from "@mui/material";
import modalThemeTextStyle from "./modal-theme-style.js";
import "../../styles/generate-captions.scss";

const SelectPlatformsDropdown = (props) => {
  const platformOptions = [
    "Facebook",
    "Instagram",
    "X (Twitter)",
    "LinkedIn",
    "YouTube",
    "Pinterest",
    "Google Business Profile",
    "TikTok",
  ];

  return (
    <FormControl>
      <Select
        labelId="multiple-chip-label"
        id="multiple-chip"
        multiple
        displayEmpty
        value={props.platform}
        onChange={props.handlePlatformChange}
        input={
          <OutlinedInput
            id="select-multiple-chip"
            label="Chip"
            sx={modalThemeTextStyle}
          />
        }
        sx={modalThemeTextStyle}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <span style={modalThemeTextStyle}>General</span>;
          }

          return (
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
              {selected?.map((value) => (
                <Chip
                  key={value}
                  label={value}
                  sx={modalThemeTextStyle}
                />
              ))}
            </Box>
          );
        }}
      >
        {platformOptions.map((p) => (
          <MenuItem key={p} value={p}>
            <input
              type="checkbox"
              data-testid="generated-caption-checkbox"
              className="generate-captions-input"
              checked={props.platform.indexOf(p) > -1}
            />
            <ListItemText
              primary={p}
              className="generate-captions-input"
              inputProps={{className: 'matching-text-family'}}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectPlatformsDropdown;
